import { Spinner } from "@myhealth-raccoon/components"
import { SerializedError } from "@reduxjs/toolkit"
import React from "react"

export const PleaseWait = ({ error }: { error?: Error | SerializedError }) => {
    return <>
        <h1 className='text-2xl text-gray-900 font-semibold mb-2.5'>Please wait</h1>
        {error
            ? <pre className='text-error whitespace-pre-wrap'>
                {error.name}: {error.message}
            </pre>
            : <Spinner className='block mx-auto w-fit' />
        }
    </>
}